import React, { useCallback, useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useFocusEffect } from '@react-navigation/core';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { ExtremeEventSection, Section } from '../../components/index';
import { useAuth } from '../../contexts/AuthContext/AuthContext';
import { useExtremeEvents } from '../../contexts/ExtremeEvent/ExtremeEventContext';
import { isMobile, isMobileWeb } from '../../utils/responsive';
import { useModules } from '../../contexts/Module/ModuleContext';
import client from '../../client/client';
import { useMessage } from '../../contexts/Messages/MessageContext';
import { PersonaType } from '../../client/interfaces';
import BirthdaySection from '../BirthdaySection';

const SectionList: React.FC = () => {
  const { extremeEvents, fetchExtremeEvents } = useExtremeEvents();
  const { modules, modulesToRoles } = useModules();
  const viewRef = useRef(null);
  const { setMessage } = useMessage();
  const { me } = useAuth();

  useFocusEffect(
    useCallback(() => {
      fetchExtremeEvents();
      if (viewRef?.current) {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }
    }, []),
  );

  const [birthdayDetail, setBirthdayDetail] = useState(null);

  useEffect(() => {
    const fetchBirthday = async () => {
      if (me?.personas?.[0]?.personaType !== PersonaType.employee) return;

      const today = new Date().toISOString().split('T')[0];

      try {
        const stored = await AsyncStorage.getItem('birthdayToday');
        const jsonBirthday = JSON.parse(stored);
        if (jsonBirthday?.data) {
          if (jsonBirthday.date === today) {
            setBirthdayDetail(jsonBirthday.data);
            return;
          }
        }

        const birthdayData = await client.getBirthdayToday();

        await AsyncStorage.setItem(
          'birthdayToday',
          JSON.stringify({
            date: today,
            data: birthdayData,
          }),
        );

        setBirthdayDetail(birthdayData);
      } catch (e) {
        console.error(e);
        setMessage({ message: e.message, type: 'error' });
      }
    };

    fetchBirthday();
  }, []);

  const { t } = useTranslation();

  const renderedElementsWeb = modules.map((section, itemIndex) => {
    const ChildComponent = section.component;
    const roles = me?.roleList;
    let showAddNew = false;

    if (roles && roles.length > 0) {
      showAddNew = roles.some((role) => role === modulesToRoles[section.key]);
    }

    return (
      ChildComponent && (
        <Section
          key={section.key}
          sectionKey={section.key}
          title={t(`section:${section.key}`)}
          showAddNew={showAddNew}
        >
          <ChildComponent />
        </Section>
      )
    );
  });

  return (
    <View ref={viewRef}>
      {birthdayDetail && birthdayDetail.anniversary && (
        <BirthdaySection anniversary={birthdayDetail.anniversary} />
      )}
      {extremeEvents.length > 0 && (
        <ExtremeEventSection
          containerStyle={{
            marginBottom:
              extremeEvents.length > 0 && isMobile
                ? 40
                : extremeEvents.length > 0 && !isMobile
                  ? 80
                  : 0,
          }}
        />
      )}
      <div
        style={{
          gap: isMobileWeb ? 40 : 80,
          display: 'flex',
          flexDirection: 'column',
          marginTop: 0,
        }}
      >
        {renderedElementsWeb}
      </div>
    </View>
  );
};
export default SectionList;
